import {InjectionToken} from '@angular/core'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'
import {TaxesEmbeddedService} from '@service/orders/taxes.embedded.service'
import {TaxesService} from '@service/orders/taxes.service'

/**
 * Factory que resuelve la implementación adecuada de `TaxesService`.
 *
 * @description
 * Devuelve `TaxesEmbeddedService` en modo embebido y `TaxesService` en
 * modo standalone. `TaxesService` calcula impuestos sobre líneas de
 * pedido aplicando las reglas fiscales configuradas.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `TaxesService`.
 */
export function providerTaxesServiceFactory(embeddedClientService: EmbeddedClientService) {
  if (embeddedClientService.isEmbeddedFunction()) {
    return new TaxesEmbeddedService()
  }
  return new TaxesService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `TaxesService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerTaxesServiceFactory}.
 */
export const TaxesServiceToken = new InjectionToken<TaxesService>('TaxesService')
